import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { Userprofile } from "src/app/_models/Userprofile";
import { UserProfileActionTypes } from "src/app/constants/StoreConstants";

export const GetOwnUserProfile = createAction(
  UserProfileActionTypes.GetOwnUserProfile
);

export const GetOwnUserProfileSuccess = createAction(
  UserProfileActionTypes.GetOwnUserProfileSuccess,
  props<{ userProfile: Userprofile }>()
);

export const GetOwnUserProfileError = createAction(
  UserProfileActionTypes.GetOwnUserProfileError,
  props<{ error: any }>()
);

export const ResetOwnUserProfile = createAction(
  UserProfileActionTypes.ResetOwnUserProfile
);

export const GetUserProfile = createAction(
  UserProfileActionTypes.GetUserProfile,
  props<{id: number}>()
);

export const GetUserProfileSuccess = createAction(
  UserProfileActionTypes.GetUserProfileSuccess,
  props<{result: Userprofile}>()
);

export const GetUserProfileError = createAction(
  UserProfileActionTypes.GetUserProfileError,
  props<{error: HttpErrorResponse}>()
);

export const UserHasAccessToLearner = createAction(
  UserProfileActionTypes.UserHasAccessToLearner,
  props<{ learnerId: number }>()
);

export const UserHasAccessToLearnerSuccess = createAction(
  UserProfileActionTypes.UserHasAccessToLearnerSuccess,
  props<{ result: boolean }>()
);

export const UserHasAccessToLearnerError = createAction(
  UserProfileActionTypes.UserHasAccessToLearnerError,
  props<{ error: HttpErrorResponse }>()
);

export const SetUserProfile = createAction(
  UserProfileActionTypes.SetUserProfile,
  props<{ userProfile: Userprofile }>()
);